/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ExceptionResponseDTO } from '../model/models';
import { GenericResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { TerminiAccettazioneForm } from '../model/models';
import { TerminiStatoDTO } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface AccettaTerminiCittadinoRequestParams {
    terminiAccettazioneForm: TerminiAccettazioneForm;
}


export interface CittadinoConsensiServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Obsoleto: risponde 200 senza registrare nulla.
     * Audience: CITTADINO autenticato. No-op mantenuto solo per i client non aggiornati: nessun consenso viene scritto.
     * @endpoint post /api/v1/cittadino/consensi/termini
* @param requestParameters
     
     * @deprecated
     */
    accettaTerminiCittadino(requestParameters: AccettaTerminiCittadinoRequestParams, extraHttpRequestParams?: any): Observable<GenericResponseDTO>;

    /**
     * Obsoleto: risponde sempre da_accettare&#x3D;false.
     * Audience: CITTADINO autenticato. Mantenuto solo per i client non aggiornati; i documenti del cittadino sono per comune (GET /api/v1/cittadino/comuni/{slug}/documenti/da-accettare).
     * @endpoint get /api/v1/cittadino/consensi/termini

     * @deprecated
     */
    getStatoTerminiCittadino(extraHttpRequestParams?: any): Observable<TerminiStatoDTO>;

}
